<div class="add-textbook-containeer p-4">
  <div class="add-textbook-header">
    <h3>Edit Textbook</h3>
  </div>

  <form class="textbook-form" [formGroup]="textBookForm">
    <div class="form-row">
      <div class="form-group">
        <label>Title <span>*</span></label>
        <input formControlName="title" placeholder="Book title" />
        <small
          class="text-danger smaller-text"
          *ngIf="
            textBookForm.get('title')?.touched &&
            textBookForm.get('title')?.hasError('required')">
          Title is required</small>
      </div>

      <div class="form-group">
        <label>Author <span>*</span></label>
        <input formControlName="author" placeholder="Author name" />
        <small
          class="text-danger smaller-text"
          *ngIf="
            textBookForm.get('author')?.touched &&
            textBookForm.get('author')?.hasError('required')">
          Author is required
        </small>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label>Publisher <span>*</span></label>
        <input formControlName="publisher" placeholder="Publisher" />
        <small
          class="text-danger smaller-text"
          *ngIf="
            textBookForm.get('publisher')?.touched &&
            textBookForm.get('publisher')?.hasError('required')">
          Publisher is required</small>
      </div>

      <div class="form-group">
        <label>Year</label>
        <input type="number" formControlName="year" placeholder="YYYY" />
        <small
          class="text-danger smaller-text"
          *ngIf="
            textBookForm.get('year')?.touched &&
            textBookForm.get('year')?.hasError('pattern')">
          Year must be a 4-digit number</small>

        <small
          class="text-danger smaller-text"
          *ngIf="
            textBookForm.get('year')?.touched &&
            textBookForm.get('year')?.hasError('range')">
          The year must be a valid number and cannot be greater than the current
          year.</small>
      </div>
    </div>

    <div class="action-row">
      <button type="button" class="btn-cancel" (click)="closePostDialog()">
        Cancel
      </button>
      <button type="button" class="save-btn" (click)="saveTextBook()" [disabled]="textBookForm.invalid">
        <i class="bi bi-floppy2-fill"></i> Save Textbook
      </button>
    </div>
  </form>
</div>